import styled from 'styled-components'
import { iPadDown } from '../../styles/mediaQueries'
import { borderWidth } from '../../styles/variables'

export const Checkbox = styled.div`
  align-items: center;
  display: flex;
  position: relative;
`

export const LabelWrapper = styled.div`
  margin-left: 0.78vw;

  ${iPadDown} {
    margin-left: 2.42vw;
  }
`

export const Label = styled.label`
  line-height: 1.5;
`

export const Input = styled.input`
  position: absolute;
  opacity: 0;
`

interface CustomCheckboxProps {
  active?: boolean
  disabled?: boolean
}

export const CustomCheckbox = styled.span<CustomCheckboxProps>`
  align-items: center;
  background-color: transparent;
  border-style: solid;
  border-color: ${({ disabled }) => (disabled ? '#999999' : 'currentColor')};
  border-radius: 0.16vw;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  display: flex;
  height: 1.25vw;
  justify-content: center;
  transition: all 0.3s ease-out;
  width: 1.25vw;
  ${borderWidth}

  ${iPadDown} {
    height: 5.27vw;
    top: 0.6vw;
    width: 5.27vw;
  }

  .checkmark-icon {
    height: 0.75vw;
    opacity: ${({ active }) => (active ? 1 : 0)};
    width: auto;

    ${iPadDown} {
      height: 3.25vw;
    }

    path {
      fill: none;
    }
  }
`
